// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609012104/js/" + chunkId + "." + {"44":"ce231d84","225":"f46507d8","481":"3fec278a","486":"0ef0c120","770":"6abb49f7"}[chunkId] + ".0.2217213585957032.chunk.js";
};